module.exports = __webpack_public_path__ + "static/media/bg2.3f974b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg2.jpg
// module id = 584
// module chunks = 0